import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const aiFirstCreateRoute: InvariantJiraRoute = {
	name: 'ai-first-create-embed',
	path: '/jira/ai-first-create/embed',
	exact: true,
	query: ['conversationChannelId', 'projectIdOrKey', 'theme?'],
};
